/**
 * Public CMS API client (no auth).
 */
import axios from "axios";
import { API } from "./api";

const cmsApi = axios.create({
  baseURL: `${API}/cms`,
  headers: { "Content-Type": "application/json" },
});

export const fetchHomepage = () => cmsApi.get("/homepage").then((r) => r.data);
export const fetchPage = (slug) => cmsApi.get(`/pages/${slug}`).then((r) => r.data);
export const fetchServices = () => cmsApi.get("/services").then((r) => r.data);
export const fetchService = (slug) => cmsApi.get(`/services/${slug}`).then((r) => r.data);
export const fetchSettings = () => cmsApi.get("/settings").then((r) => r.data);
export const fetchBlogList = () => cmsApi.get("/blog").then((r) => r.data);
export const fetchBlogPost = (slug) => cmsApi.get(`/blog/${slug}`).then((r) => r.data);

// Public read of generic collections (testimonials, faqs, team, partners, etc.)
export const fetchCollection = (name) => cmsApi.get(`/${name}`).then((r) => r.data);

export default cmsApi;
